import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Grommet, Main } from 'grommet';

import Global from 'src/styles/Global';
import { theme } from 'src/styles/theme';
import { PATHS } from 'src/constants/paths';
import useRefreshSession from 'src/hooks/useRefreshSession';
import AuthorizedRoute from 'src/route/AuthorizedRoute';
import NotAuthorizedRoute from 'src/route/NotAuthorizedRoute';
import FullPageSpinner from 'src/components/FullPageSpinner';
import WorkSessionsPage from './work-sessions';
import LoginPage from './login';
import LogoutPage from './logout';

function AppLayout(): JSX.Element {
  const isRefreshingSession = useRefreshSession();

  const renderContent = () => {
    if (isRefreshingSession) {
      return <FullPageSpinner isLoading />;
    }

    return (
      <Routes>
        <Route path={PATHS.HOME} element={<Navigate to={PATHS.WORK_SESSIONS} />} />
        <Route
          path={PATHS.WORK_SESSIONS}
          element={
            <AuthorizedRoute>
              <WorkSessionsPage />
            </AuthorizedRoute>
          }
        />
        <Route
          path={PATHS.LOGOUT}
          element={
            <AuthorizedRoute>
              <LogoutPage />
            </AuthorizedRoute>
          }
        />
        <Route
          path={PATHS.LOGIN}
          element={
            <NotAuthorizedRoute>
              <LoginPage />
            </NotAuthorizedRoute>
          }
        />
        {/* TODO: add redirect to 404 page */}
        <Route path='*' element={<Navigate to={PATHS.HOME} />} />
      </Routes>
    );
  };

  return (
    <Grommet theme={theme} full='min'>
      <Global />
      <Main pad='small' fill>
        {renderContent()}
      </Main>
    </Grommet>
  );
}

export default AppLayout;
